import { Component, HostBinding, Input } from '@angular/core';
import { PAYMENT_COMPS } from 'src/app/core';
import { PaymentStepperNewEvent } from 'src/app/shared';

@Component({
  template: '',
})
export abstract class Step<event extends PaymentStepperNewEvent> {
  @HostBinding('class.disabled') @Input('disabled') disabled: boolean = false;

  protected _name!: PAYMENT_COMPS;

  constructor(name: PAYMENT_COMPS) {
    this.register(name);
  }

  abstract next(to: number): void;
  abstract previous(): void;

  private register(name: PAYMENT_COMPS) {
    this._name = name;
  }

  protected get name(): PAYMENT_COMPS {
    return this._name;
  }

  protected generateEvent(
    name: PaymentStepperNewEvent['name'],
    payload: PaymentStepperNewEvent['payload']
  ): PaymentStepperNewEvent {
    return { name, payload, comp: this._name };
  }
}
